export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/slideshow_videos.5dc0f0d.svg";